import dynamic from 'next/dynamic';

export const PinnedNews = dynamic(() => import('./PinnedNews'));
export const NewsOverView = dynamic(() => import('./NewsOverview'));
export const NewsDetail = dynamic(() => import('./NewsDetail'));
export const LastestNews = dynamic(() => import('./LastestNews'));
export const OthersNews = dynamic(() => import('./OthersNews'));
export const CategoryNewsDetail = dynamic(() => import('./CategoryNewsDetail'));
export const InteractionIsland = dynamic(() => import('./InteractionIsland'));
export const DetailNewsPage = dynamic(() => import('./DetailNewsPage'));

export const NewsCategoryRight = dynamic(() => import('./NewsCategoryRight'));
export const NewsCategoryLeft = dynamic(() => import('./NewsCategoryLeft'));
export const TopNewsPage = dynamic(() => import('./TopNewsPage'));
